import { Component, OnInit, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { ChartConfig, ChartValue} from 'src/interfaces/dashboard';

@Component({
    selector: 'core-statistics',
    templateUrl: './statistics.component.html',
    styleUrls: ['./statistics.component.scss'],
    standalone: false
})
export class StatisticsComponent implements OnInit {

  single: any[];
  multi: any[];

  @Input() heading: string;
  @Input() data: ChartValue[];
  @Input() config: ChartConfig;
  view: [number, number] = [900, 300];

  constructor() { }

  ngOnInit(): void {
  }

  onSelect(event: any) {
  }

}
